import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { mockData } from '../utils/mock';
import { Linkedin, Github, Instagram, Youtube, Twitter } from 'lucide-react';

const SocialIcons = ({ className = '' }) => {
  const social = (mockData && mockData.social) || {};
  const items = [
    { key: 'linkedin', icon: Linkedin, href: social.linkedin, label: 'LinkedIn' },
    { key: 'github',   icon: Github,   href: social.github,   label: 'GitHub' },
    { key: 'instagram',icon: Instagram,href: social.instagram,label: 'Instagram' },
    { key: 'youtube',  icon: Youtube,  href: social.youtube,  label: 'YouTube' },
    { key: 'twitter',  icon: Twitter,  href: social.twitter,  label: 'Twitter/X' },
  ];

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {items.map(({ key, icon: Icon, href, label }) => {
        const base =
          'inline-flex items-center justify-center w-9 h-9 rounded-lg border border-gray-800 bg-gray-900 text-gray-300 hover:text-white hover:border-gray-700 hover:bg-gray-800 transition';
        return href ? (
          <a key={key} href={href} target="_blank" rel="noopener noreferrer" className={base} aria-label={label} title={label}>
            <Icon className="w-4 h-4" />
          </a>
        ) : (
          <span key={key} className={`${base} opacity-40 cursor-not-allowed`} aria-disabled="true" title={label}>
            <Icon className="w-4 h-4" />
          </span>
        );
      })}
    </div>
  );
};

export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* GRID: [2 colunas à esquerda] + [Navegação] + [Serviços] */}
        <div className="grid md:grid-cols-4 gap-8">
          {/* Logo e descrição ocupando 2 colunas */}
          <div className="md:col-span-2">
            <div className="text-2xl font-bold mb-4">
              <span className="text-primary">Hack</span>
              <span className="text-secondary"> a Tech</span>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              {t('footer.description')}
            </p>
            <div className="space-y-2 text-sm text-gray-300">
              <p>{t('footer.contact.email')} {mockData.contact.email}</p>
              <p>{t('footer.contact.phone')} {t('footer.contact.phoneValue')}</p>
              <p>{t('footer.contact.service')}</p>
              <p>Hack a Tech Serviços em Tecnologia LTDA</p>
              <p>CNPJ: 40.061.334/0001-90</p>
            </div>
          </div>

          {/* Navegação (col 3) */}
          <div>
            <h3 className="font-semibold text-lg mb-4">{t('footer.navigation')}</h3>
            <ul className="space-y-2 text-gray-300">
              <li>
                <button onClick={() => scrollToSection('sobre')} className="hover:text-primary transition-colors duration-200">
                  {t('nav.about')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('servicos')} className="hover:text-primary transition-colors duration-200">
                  {t('nav.services')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('diferenciais')} className="hover:text-primary transition-colors duration-200">
                  {t('nav.differentials')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contato')} className="hover:text-primary transition-colors duration-200">
                  {t('nav.contact')}
                </button>
              </li>
            </ul>
          </div>

          {/* Serviços (col 4) */}
          <div>
            <h3 className="font-semibold text-lg mb-4">{t('footer.services')}</h3>
            <ul className="space-y-2 text-gray-300 text-sm">
              {t('footer.servicesList').map((service, index) => (
                <li key={index}>{service}</li>
              ))}
            </ul>
          </div>

          {/* ---- ÍCONES SOCIAIS: abaixo de Navegação+Serviços, ocupando colunas 3 e 4 ---- */}
          <div className="md:col-start-0 md:col-span-4">
            <hr />
          </div>
          <div className="md:col-start-2 md:col-span-2">
            <SocialIcons className="mt-6 justify-center" />
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} Hack a Tech. {t('footer.rights')}
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <button className="text-gray-400 hover:text-primary transition-colors duration-200 text-sm">
                {t('footer.privacy')}
              </button>
              <button className="text-gray-400 hover:text-primary transition-colors duration-200 text-sm">
                {t('footer.terms')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
